import { Amplify } from "aws-amplify"

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID, //config("aws.cognito.userPoolId"),
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID, //config("aws.cognito.userPoolClientId"),
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: "code",
      userAttributes: {
        email: {
          required: true,
        },
      },
    },
  },
})
